import { RunMode } from '@amzn/taskscheduling-service';

export interface TaskExecutionItem {
  taskId?: string;
  taskVersion?: number;
  executionId?: string;
  executedBy?: string;
  runMode?: RunMode | string;
  time?: string;
  status?: string;
  metadata?: string;
  closeMonth?: string;
  datasetStartPeriod?: string;
  datasetEndPeriod?: string;
  dataSourceConfig?: Record<string, string>;
}
